
import axios from 'axios'

export default {
    getGroup(){
        return axios.get('/group')
            .then(response => {
                return response.data
            })
    },
    getGroupDataSource(params){
        return axios.get('/group/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getGroupbyID(id){
        return axios.get('/group/' + id)
            .then(response => {
                return response.data
            })
    },
    createGroup(formdata){
        return axios.post('/group', formdata)
            .then(response => {
                return response.data
            })
    },
    updateGroup(id,formdata){
        return axios.put('/group/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateGroup(id){
        return axios.put('/group/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateGroup(id){
        return axios.put('/group/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    updateCoach(id,formdata){
        return axios.put('/group/' + id + '/manage-coach' ,formdata)
            .then(response => {
                return response.data
            })
    },
    updateIcare(id,formdata){
        return axios.put('/group/' + id + '/manage-icare',formdata)
            .then(response => {
                return response.data
            })
    },
    removeCoach(id){
        return axios.put('/group/' + id + '/remove-coach')
            .then(response => {
                return response.data
            })
    },

}